import React from 'react';
import uniqueId from 'lodash.uniqueid';
import classNames from 'classnames';

const ProductsList = (props) => {
    const
        productItems = props.productsList.map((product) => makeProductItem(product)),
        productListClasses = classNames(
            'flowList',
            'flowList--products',
            'few',
            {
                'flowList--horizontal': props.layoutType === ProductsList.layoutTypes.list,
                'loading': props.isLoading
            });

    return (
        <div id="productsList" aria-live="polite" aria-relevant="additions removals">
            <h2 className="visually-hidden-accessible">Product list</h2>
            <ul id="productCatalogueSearchResults" className={productListClasses}>
                {productItems}
            </ul>
        </div>
    );
};

ProductsList.layoutTypes = {list: 'list', grid: 'grid'};

function makeProductItem(product) {
    const
        isArticle = product.Number.toString().toLowerCase().startsWith('article'),
        hasImage = product.ImageUrl.trim().length > 0,
        imageContainerClasses = classNames('img-flow', 'ratio-16-9', {'img-flow--no-img': !hasImage});

    return (
        <li className="flowList__item" key={uniqueId()}>
            <figure>
                <a href={product.ExternalUrl}>
                    <div className={imageContainerClasses}>
                        {hasImage
                            ? <img src={product.ImageUrl} alt={product.Name}/>
                            : null
                        }
                    </div>
                </a>
            </figure>
            {product.SupersedesProductInfo &&
            <p className="flowList__additional-info">{product.SupersedesProductInfo}</p>
            }
            <div className="flowList__item-content">
                <h3><a href={product.ExternalUrl}>{product.Name}</a></h3>
                <p className="preview-intro">{product.Description}</p>
                {isArticle
                    ? null
                    : <p><span>Product number: <strong>{product.Number}</strong></span></p>
                }
            </div>
        </li>
    )
}

export default ProductsList;


